import React from "react";
import { Async } from "react-select";
import Overlay from "../../../components/overlay";
import Dialog from "../../../components/dialog";
import { getStores } from "../../../backend/stores";
import MachineSwap from "../machine-swap";

export default function() {
  const {
    machines = [],
    tools = [],
    storeSelect,
    loading,
    showSwapOverlay,
    store,
    machineSwapId,
    toolSwapId,
    showHireDetailOverlay,
    hireDetails,
  } = this.state;
  return (
    <div>
      <label>Store Location {store !== undefined && this._getStoreHours(store)}</label>
      <Async
        value={storeSelect}
        loadOptions={getStores}
        onChange={this._selectStore}
      />
      <div>
        {loading && <Overlay />}
        <h4>Machines</h4>
        {machines.length === 0 &&
          !loading && (
            <div className="placeholder">
              {navigator.onLine ? "No machines" : "Could not retreive machines"}
            </div>
          )}
        {machines.map((machine, index) => this._renderMachine(machine, index))}
        <h4>Tools</h4>
        {tools.length === 0 &&
          !loading && (
            <div className="placeholder">
              {navigator.onLine ? "No tools" : "Could not retreive tools"}
            </div>
          )}
        {tools.map((tool, index) => this._renderTool(tool, index))}
      </div>
      {showSwapOverlay && (
        <Dialog close={this._closeSwapDialog}>
          <MachineSwap
            machineId={machineSwapId}
            toolId={toolSwapId}
            closeDialog={this._closeSwapDialog}
          />
        </Dialog>
      )}

      {showHireDetailOverlay && (
        <Dialog close={this._closeHireDetailDialog}>
          <div>
            <h4>Hire Details</h4>
            <p className="text-left"><strong>Return date</strong> : {hireDetails.return_date}</p>
            <p className="text-left"><strong>Customer</strong> : {hireDetails.customer_name}</p>
            <p className="text-left"><strong>Contacts (phone)</strong> : {hireDetails.customer_contact_p}</p>
            <p className="text-left"><strong>Contacts (email)</strong> : {hireDetails.customer_contact_e}</p>
            <p className="text-left"><strong>Address</strong> : {hireDetails.customer_address}</p>
          </div>
          <button onClick={this._closeHireDetailDialog}>Close</button>
        </Dialog>
      )}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/screens/machines/machine-list/view.js